import { motion, AnimatePresence } from "framer-motion";
import { useStore } from "./store/useStore";
import { DashboardLayout } from "./components/layout/DashboardLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
// import Compare from "./pages/Compare";
import Upload from "./pages/Upload";
import Chat from "./pages/Chat";

export default function App() {
  const { isAuthenticated, activeTab } = useStore();

  if (!isAuthenticated) return <Login />;

  return (
    <DashboardLayout>
      <AnimatePresence mode="wait">
        {activeTab === "dashboard" && (
          <motion.div key="dash" exit={{ opacity: 0 }}>
            <Dashboard />
          </motion.div>
        )}
        {/* {activeTab === "compare" && (
          <motion.div key="comp" exit={{ opacity: 0 }}>
            <Compare />
          </motion.div>
        )} */}
        {activeTab === "compare" && (
          <motion.div key="comp-disabled" exit={{ opacity: 0 }}>
            <Dashboard />
          </motion.div>
        )}
        {activeTab === "upload" && (
          <motion.div key="up" exit={{ opacity: 0 }}>
            <Upload />
          </motion.div>
        )}
        {activeTab === "chat" && (
          <motion.div key="chat" exit={{ opacity: 0 }} className="h-full">
            <Chat />
          </motion.div>
        )}
      </AnimatePresence>
    </DashboardLayout>
  );
}
